import { render, staticRenderFns } from "./OperaCarsWindow.vue?vue&type=template&id=3ed7f345&"
import script from "./OperaCarsWindow.vue?vue&type=script&lang=js&"
export * from "./OperaCarsWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports